<template>
  <div class="justify-center">
    <div class="q-card q-pa-xl full-height">
      <q-form
        class="q-gutter-md"
        @submit.prevent="handleSubmit"
        @reset="onReset"
        style="min-width: 90vw"
        ref="signinform"
      >
        <h4 class="row">{{ $t("signin") }}</h4>
        <div class="row q-gutter-sm">
          <div class="col-12 col-md-6">
            <q-input
              v-model="form.username"
              :label="$t('username_signin') + ' *'"
              autofocus="autofocus"
              maxlength="150"
              id="id_username"
              autocomplete="__no_autocomplete_please"
              required
              :rules="[richiesto]"
              :error="v$.username.$invalid && v$.username.$dirty"
  :error-message="v$.username.$errors[0]?.$message"
  @blur="v$.username.$touch()"
            />
          </div>
          <div class="col">
            <q-input
              v-model="form.email"
              type="email"
              :label="$t('E-mail') + ' *'"
              id="id_email"
              required
              :rules="[richiesto, isValidEmail]"
              reactive-rules
              :error="v$.email.$invalid && v$.email.$dirty"
  :error-message="v$.email.$errors[0]?.$message"
  @blur="v$.email.$touch()"
            />
          </div>
        </div>
        <div class="row q-gutter-sm">
          <div class="col">
            <q-input
              v-model="form.password"
              type="password"
              :label="$t('Password') + ' *'"
              id="id_password"
              autocomplete="__no_autocomplete_pwd"
              required
              :rules="[richiesto]"
              ref="passwordChangeConfirm"
              :error="v$.password.$invalid && v$.password.$dirty"
  :error-message="v$.password.$errors[0]?.$message"
  @blur="v$.password.$touch()"
            />
          </div>
          <div class="col">
            <q-input
              v-model="form.password_repeat"
              type="password"
              :label="$t('Password (ripetere)') + ' *'"
              id="id_password_repeat"
              required
              reactive-rules
              :rules="[richiesto, passwordCoincidono]"
              :error="v$.password_repeat.$invalid && v$.password_repeat.$dirty"
  :error-message="v$.password_repeat.$errors[0]?.$message"
  @blur="v$.password_repeat.$touch()"
            />
          </div>
        </div>
        <div class="row q-gutter-sm">
          <div class="col">
            <q-input
              v-model="form.first_name"
              type="text"
              :label="$t('Nome') + ' *'"
              id="id_nome"
              required
              :rules="[richiesto]"
              reactive-rules
              :error="v$.first_name.$invalid && v$.first_name.$dirty"
  :error-message="v$.first_name.$errors[0]?.$message"
  @blur="v$.first_name.$touch()"
            />
          </div>
          <div class="col">
            <q-input
              v-model="form.last_name"
              type="text"
              :label="$t('Cognome') + ' *'"
              id="id_cognome"
              required
              :rules="[richiesto]"
              reactive-rules
              :error="v$.last_name.$invalid && v$.last_name.$dirty"
  :error-message="v$.last_name.$errors[0]?.$message"
  @blur="v$.last_name.$touch()"
            />
          </div>
        </div>
        <div class="row q-gutter-sm">
          <div class="col">
            <q-select
              v-model="form.tipo_cliente"
              :options="opzioni_tipo_cliente"
              :label="$t('Tipo utente') + ' *'"
              id="id_tipo_cliente"
              emit-value
              map-options
              required
              :rules="[richiesto]"
              reactive-rules
              :error="v$.tipo_cliente.$invalid && v$.tipo_cliente.$dirty"
  :error-message="v$.tipo_cliente.$errors[0]?.$message"
  @blur="v$.tipo_cliente.$touch()"
            />
          </div>
          <div class="col">
            <q-input
              v-model="form.ragione_sociale"
              type="text"
              :label="$t('Ragione sociale') + ' *'"
              id="id_ragione_sociale"
              required
              :rules="[richiesto]"
              reactive-rules
              :error="v$.ragione_sociale.$invalid && v$.ragione_sociale.$dirty"
  :error-message="v$.ragione_sociale.$errors[0]?.$message"
  @blur="v$.ragione_sociale.$touch()"
            />
          </div>
        </div>
        <div class="row q-gutter-sm">
          <div class="col">
            <q-input
              v-model="form.localita"
              type="text"
              :label="
                isProvinciaRequired ? $t('Localita') + ' *' : $t('Localita')
              "
              :required="isProvinciaRequired"
              :rules="[richiestoSeInItalia]"
              id="id_localita"
              :error="v$.localita.$invalid && v$.localita.$dirty"
  :error-message="v$.localita.$errors[0]?.$message"
  @blur="v$.localita.$touch()"
            />
          </div>
                    <div class="col">
            <q-input
              v-model="form.provincia"
              type="text"
              :label="
                isProvinciaRequired ? $t('Provincia') + ' *' : $t('Provincia')
              "
              :required="isProvinciaRequired"
              :rules="[richiestoSeInItalia]"
              id="id_provincia"
              :error="v$.provincia.$invalid && v$.provincia.$dirty"
  :error-message="v$.provincia.$errors[0]?.$message"
  @blur="v$.provincia.$touch()"
            />
          </div>

          <div class="col">
            <q-select
              v-model="form.stato"
              :options="countryList"
              :label="$t('Stato') + ' *'"
              id="id_stato"
              required
              :rules="[richiesto]"
              reactive-rules
              :error="v$.stato.$invalid && v$.stato.$dirty"
  :error-message="v$.stato.$errors[0]?.$message"
  @blur="v$.stato.$touch()"
            />
          </div>
        </div>
        <div class="row q-gutter-sm">
          <div class="col">
            <q-input
              v-model="form.cell"
              type="text"
              :label="$t('Cellulare') + ' *'"
              id="id_cell"
              required
              :rules="[richiesto]"
              reactive-rules
              :error="v$.cell.$invalid && v$.cell.$dirty"
  :error-message="v$.cell.$errors[0]?.$message"
  @blur="v$.cell.$touch()"
            />
          </div>
        </div>
        <div class="col">
          <q-toggle
            v-model="form.privacy"
            :label="$t('privacy')"
            class="q-mr-md"
            ref="privacyRef"

          />
          <a
            v-if="locale == 'it-it'"
            href="https://palicampion.it/site/pagine/dynamic_art.php?table_name=2018_privacy&id=1"
            class="color-muted text-caption"
            target="_blank"
            >({{ $t("maggiori informazioni") }})</a
          >
          <a
            v-else
            href="https://palicampion.it/site/eng_pagine/dynamic_art.php?table_name=2018_eng_privacy&id=1"
            class="color-muted text-caption"
            target="_blank"
            >({{ $t("maggiori informazioni") }})</a
          >
          <span class="q-ml-md text-negative text-caption">{{privacyErrorMessage}}</span>
        </div>
        <q-banner
          v-if="errorMessage"
          inline-actions
          :class="isHandledWarning ? 'text-dark bg-warning' : 'text-white bg-red'"
        >
          {{ errorMessage }}
          <template v-slot:action>
            <q-btn
              flat
              :color="isHandledWarning ? 'dark' : 'white'"
              label="OK"
              @click="errorMessage = null; isHandledWarning = false"
            />
          </template>
        </q-banner>
        <div class="row q-gutter-x-md q-py-lg">
          <div class="col"></div>
          <q-btn
            rounded
            color="grey"
            :label="$t('indietro')"
            type="button"
            class="col"
            @click="$emit('go-back')"
          />
          <q-btn
            rounded
            color="primary"
            :label="$t('submit')"
            type="submit"
            class="col"
          />
          <div class="col"></div>
        </div>
      </q-form>
    </div>
  </div>
</template>
<script setup>
import { ref, reactive, computed, onMounted, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { useMainStore } from "../stores/main";
import { useVuelidate } from "@vuelidate/core";
import { required, email, helpers, requiredIf } from "@vuelidate/validators";
import * as Sentry from "@sentry/vue";
import { countryList as rawCountryList } from "../services/countries";
import { AUTH_ERROR_CODES, signinUser } from "../services/api/auth";
import { shouldReportToSentry } from "../services/error-handling";
import { useReCaptcha } from 'vue-recaptcha-v3';

/* ---------- stato ---------- */
const store = useMainStore();
const router = useRouter();
const route = useRoute();
const { t, locale } = useI18n();
const { executeRecaptcha, recaptchaLoaded } = useReCaptcha();

/* campi utente / azienda */
const form = reactive({
  username: "",
  password: "",
  password_repeat: "",
  first_name: "",
  last_name: "",
  email: "",
  ruolo: "",
  tipo_cliente: "",
  ragione_sociale: "",
  indirizzo: "",
  localita: "",
  provincia: "",
  stato: "",
  cap: "",
  tel: "",
  fax: "",
  web: "",
  cell: "",
  privacy: false,
});

/* altri stati */
const nextPath = ref("/dashboard/");
const errorMessage = ref(null);
const isHandledWarning = ref(false);
//const recaptchaRef = ref("");
const captchaToken = ref("");
const privacyErrorMessage = ref("");
const countryList = ref([]); // sarà popolato in mounted & watch
const opzioni_tipo_cliente = ref([
  {
    label: t("Rivenditore"),
    value: "Rivenditore",
  },
  {
    label: t("Installatore"),
    value: "Installatore",
  },
  {
    label: t("Impresa Costruzioni"),
    value: "Impresa Costruzioni",
  },
  {
    label: t("Azienda utilizzatrice"),
    value: "Azienda utilizzatrice",
  },
  {
    label: t("Ente"),
    value: "Ente",
  },
  {
    label: t("Studio Progettazione"),
    value: "Studio Progettazione",
  },
  {
    label: t("Agente di commercio"),
    value: "Agente di Commercio",
  },
  {
    label: t("Privato"),
    value: "Privato",
  },
]);

/* ---------- Vuelidate ---------- */
const isProvinciaRequired = computed(() => {
  const stato = form.stato.value ?? ''
  console.log(stato.slice(0,2).toLowerCase())
  return typeof stato === 'string' &&
         stato.slice(0, 2).toLowerCase() === 'it'
})

const richiesto = helpers.withMessage(
  t("richiesto"), // messaggio tradotto UNA sola volta
  required,
);

const passwordCoincidono = helpers.withMessage(
  t("non corrispondono"),
  (v) => v === form.password,
);

const richiestoSeInItalia = helpers.withMessage(
  t("richiesto"),
  requiredIf(() => isProvinciaRequired.value),
);

const daAccettare = helpers.withMessage(
  t("privacy richiesta"),
  (val) => val, // restituisce true solo se il campo stesso è true, non accetta valori false.
);
const isValidEmail = helpers.withMessage(t("Email non valida"), email);
const rules = {
  username: { richiesto },
  email: { richiesto, isValidEmail },
  password: { richiesto },
  password_repeat: { richiesto, passwordCoincidono },
  first_name: { richiesto },
  last_name: { richiesto },
  tipo_cliente: { richiesto },
  ragione_sociale: { richiesto },
  localita: { richiestoSeInItalia },
  provincia: { richiestoSeInItalia },
  stato: { richiesto },
  cell: { richiesto },
  privacy: { daAccettare },
};

const v$ = useVuelidate(rules, form);

watch(locale, () => {
  rebuildOptions();
});

function rebuildOptions() {
  /* traduci countryList

forse da fare anche per opzioni_tipo_cliente
*/
  countryList.value = rawCountryList.map((c) => ({
    value: c,
    label: c, // in futuro qui potrei tradurlo
  }));
}



/* ---------- submit ---------- */
async function handleSubmit() {
  if (form.privacy) {
    console.log('privacy ok')
    privacyErrorMessage.value = "";
  } else {
    console.log('errore privacy')
    privacyErrorMessage.value = t("privacy richiesta");
  }

  const ok = await v$.value.$validate();
  console.log(ok)
  if (!ok) return;

  console.log('recaptcha');
  const ok_captcha =await recaptchaLoaded()
  console.log('captcha loaded?', ok_captcha)
  const token = await executeRecaptcha('signin')
  captchaToken.value = token

  try {
    console.log('signin');
    await signinUser({
      ...form,
      captcha: captchaToken.value,
    });
    console.log('store login')
    await store.login({ username: form.username, password: form.password });
    console.log('next!')
    router.push(nextPath.value);
  } catch (err) {
    console.log(err)
    if (
      err?.code === AUTH_ERROR_CODES.USERNAME_ALREADY_EXISTS ||
      err?.code === AUTH_ERROR_CODES.INVALID_USERNAME ||
      err?.isHandled === true
    ) {
      errorMessage.value = err.message
      isHandledWarning.value = true
      console.warn('[handled-warning]', err.message)
    } else {
      errorMessage.value = t(
        "Impossibile accedere, verificare le credenziali inserite.",
      );
      isHandledWarning.value = false
      if (shouldReportToSentry(err)) {
        Sentry.captureException(err);
      }
    }
    // reset captcha sul fallimento
    // recaptchaRef.value.reset();
    captchaToken.value = "";
  }
}

/* ---------- reset ---------- */
function onReset() {
  Object.keys(form).forEach(
    (k) => (form[k] = typeof form[k] === "boolean" ? false : ""),
  );
  errorMessage.value = null;
  isHandledWarning.value = false;
  privacyErrorMessage.value = "";
  captchaToken.value = "";
}

/* ---------- mounted ---------- */
onMounted(() => {
  if ("next" in route.query) nextPath.value = route.query.next;
  rebuildOptions();
});

/* ---------- expose (se il parent stepper lo chiama) ---------- */
defineExpose({ handleSubmit });
</script>
